import { render } from "./Logo.vue?vue&type=template&id=2244bfa6&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=2244bfa6&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2244bfa6"]])

export default __exports__